import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsConfigRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-config',
	path: '/plugins/servlet/project-config/:projectKey/:adminOption',
};
